import { render, staticRenderFns } from "./WorkCompetitionEdit.vue?vue&type=template&id=0b31c726&scoped=true"
import script from "./WorkCompetitionEdit.vue?vue&type=script&lang=js"
export * from "./WorkCompetitionEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkCompetitionEdit.vue?vue&type=style&index=0&id=0b31c726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31c726",
  null
  
)

export default component.exports